import React, {FunctionComponent, useContext, useState} from "react";
import {ChallengeProtocolData} from "/src/domain/challenges/ChallengeProtocolData";
import {User} from '/src/domain/shared/User';
import AuthorizeDialog from "/src/ui/shared/AuthorizeDialog";
import AppealDialog from "/src/ui/shared/AppealDialog";
import UserFeedbackButtons from "/src/ui/challengeProtocol/userFeedback/UserFeedbackButtons";
import Audit from "/src/ui/challengeProtocol/audit/Audit";
import {Collapse} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {PageContext, PageContextProps} from "/src/contexts/Page";

interface UserFeedbackData {
    challengeProtocol: ChallengeProtocolData;
    currentUser?: User;
    authUrl?: string;
}

const UserFeedback: FunctionComponent<UserFeedbackData> = ({challengeProtocol, currentUser}) => {
    const classes = useStyles()
    const [isAuthorizeDialogOpen, setAuthorizeDialogOpen] = useState(false)
    const [isAppealDialogOpen, setAppealDialogOpen] = useState(false)
    const [isAuditVisible, setAuditVisible] = useState(false)
    const {pageConfig} = useContext(PageContext) as PageContextProps;
    const authorized = !!currentUser
    const handleAudit = (): void => {
        authorized ? setAuditVisible(!isAuditVisible) : setAuthorizeDialogOpen(true)
    }
    const handleQuestion = (): void => {
        window.open(pageConfig?.chatLink ? pageConfig?.chatLink : 'https://t.me/S10_Challenges', '_blank')
    }
    const handleAppeal = (): void => {
        if (!authorized) {
            return setAuthorizeDialogOpen(true);
        }
        if (pageConfig?.appealLink) {
            window.open(pageConfig?.appealLink);
        } else {
            setAppealDialogOpen(true);
        }
    }
    const closeDialog = (): void => {
        setAuthorizeDialogOpen(false)
    }
    const closeAppealDialog = (): void => {
        setAppealDialogOpen(false)
    }
    return (
        <div className={classes.container}>
            <AuthorizeDialog
                isDialogOpen={isAuthorizeDialogOpen}
                closeDialog={closeDialog}
                authUrl={pageConfig?.authUrl}
            />
            <AppealDialog
                isDialogOpen={isAppealDialogOpen}
                closeDialog={closeAppealDialog}
                challengeProtocol={challengeProtocol}
                currentUser={currentUser}
            />
            <UserFeedbackButtons
                currentUser={currentUser}
                challengeProtocol={challengeProtocol}
                handleAudit={handleAudit}
                handleQuestion={handleQuestion}
                handleAppeal={handleAppeal}
            />
            <Collapse in={isAuditVisible}>
                <Audit
                    currentUser={currentUser}
                    challengeKey={challengeProtocol.challenge.challengeKey}
                />
            </Collapse>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        margin: '1.5rem 0 1.5rem'
    }
})


export default UserFeedback